import { Module } from "vuex";
import { RootState } from "..";
import { Snackbar, CartSnackbar } from "@/models/UI";

export interface UIState {
  snackbar: Snackbar;
  versionSnackbar: Snackbar;
  cartSnackbar: CartSnackbar;
  isSmScreen: boolean;
  isMobileViewDisplayed: boolean;
  isSwitchingOrderType: boolean;
}

export default <Module<UIState, RootState>>{
  namespaced: true,
  state: {
    snackbar: {
      show: false,
      error: false,
      message: "",
    },
    versionSnackbar: {
      show: false,
      error: false,
      message: "",
    },
    cartSnackbar: {
      show: false,
      error: false,
      message: "",
    },
    isSmScreen: false,
    isMobileViewDisplayed: true,
    isSwitchingOrderType: false
  } as UIState,

  mutations: {
    snackbar(state: UIState, snackbar: Snackbar) {
      state.snackbar = snackbar;
    },

    versionSnackbar(state: UIState, snackbar: Snackbar) {
      state.versionSnackbar = snackbar;
    },

    cartSnackbar(state: UIState, snackbar: CartSnackbar) {
      state.cartSnackbar = snackbar;
    },

    SET_SCREEN_SIZE(state, isSmScreen) {
      state.isSmScreen = isSmScreen;
    },
    
    SET_MOBILE_VIEW(state, isMobileViewDisplayed: boolean) {
      state.isMobileViewDisplayed = isMobileViewDisplayed;
    },

    SET_IS_SWITCHING_ORDER_TYPE(state, isSwitchingOrderType: boolean) {
      state.isSwitchingOrderType = isSwitchingOrderType;
    },
  }
};
